<template>
  <div class="product-detail-box">
    <van-sticky>
      <van-nav-bar title="商品详情" left-arrow @click-left="onClickLeft" />
    </van-sticky>
    <van-swipe :autoplay="3000">
      <van-swipe-item v-for="item in gallery" :key="item.id">
        <img :src="item" />
      </van-swipe-item>
    </van-swipe>
    <van-notice-bar
      v-if="announcement != '' && announcement != null"
      left-icon="volume-o"
      :text="announcement"
    />
    <!-- 商品信息 -->
    <div class="prod-info">
      <div class="tit-wrap">
        <div class="prod-tit">{{ info.prodName }}</div>
        <div @click="clickFn" class="col">
          <img
            v-if="star_flag == true"
            src="../../assets/images/prod-col-red.png"
            alt=""
            srcset=""
          />
          <img
            v-if="star_flag == false"
            src="../../assets/images/prod-col.png"
            alt=""
            srcset=""
          />
          收藏
        </div>
      </div>
      <!-- 普通商品价格 -->
       <!-- <div>

        <div class="prod-price">
        <span class="price">￥</span
        ><span class="price-num">{{ info.price }}</span>
      </div>
      <div class="prod-price">
        <span class="price">原价</span
        ><span class="price-num">{{ info.oriPrice }}</span>
      </div>
       </div>-->
       <div style="display: flex;align-items: baseline;"> 
          <div class="prod-price" style="display: flex; align-items: center;">
            <template v-if="activityId === 9 || activityId === 13">
              <img src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" alt="积分" style="width: 16px; height: 16px; margin-right: 4px;"/>
            </template>
            <span v-else class="symbol">￥</span>
            <span class="big-num">{{ Math.floor(info.price) }}</span>
            <span class="small-num">.{{ ((info.price % 1) * 100).toFixed(0).padStart(2, '0') }}</span>
          </div>
          <div class="prices" style="margin-left: 10px;" v-if="activityId != 16">
            <span class="symbols">原价：</span>
            <span class="ori-price">{{ Math.floor(info.oriPrice) }}</span>
            <span class="ori-price">.{{ ((info.oriPrice % 1) * 100).toFixed(0).padStart(2, '0') }}</span>
          </div>
        </div>
      <p style="line-height: 25px; color:#7d7d7d;">销量：{{ info.soldNum }}</p>
    </div>
    <!-- 已选规格 -->
    <!-- <div class="sku box-radius" @click="showSku">
      <div class="sku-tit">已选</div>
      <div class="more">...</div>
    </div> -->
    <!-- 已选规格end -->
    <!-- 产品详情 -->
    <!-- <div class="mytitle">
            <span></span>
            <h3>产品详情</h3>
        </div> -->
        <!-- 是否有默认地址 -->
        <div style="margin-top: 10px;">
          <div class="skus box-radius" style="background-color: #ffffff;" :class="{'flashing': isFlashing}" id="sku-view" v-if="!addressState" @click="toAddressList">
            <div style="display: flex; justify-content: space-between; padding: 10px;">
              <div>配送至</div>
              <div class="sku-cons" style="color: red;">请先设置默认收货地址<span class="cmt-more"></span></div>
            </div>
          </div>
        </div>

        <div class="skus box-radius" v-if="addressState" @click="toAddressList"  style="background-color: #ffffff;" >
          <div style="display: flex; justify-content: space-between; padding: 10px;">
            <div>配送至</div>
            <div class="sku-cons" style="color: red;">{{addressList.province}}{{addressList.city}}{{addressList.area}}<span class="cmt-more"></span></div>
          </div>
        </div>
        <!-- 是否有默认地址end -->
    <!-- 评论 -->
    <div class="cmt-wrap box-radius">
      <div class="cmt-tit">
        <div class="cmt-t">
          评论
          <span class="cmt-good">好评%</span>
        </div>
        <div class="cmt-count">
          共{{ prodCommData.number }}条
          <span class="cmt-more"></span>
        </div>
      </div>
      <div class="cmt-cont">
        <div class="cmt-tag">
          <span>全部({{ prodCommData.number }})</span>
          <span>好评({{ prodCommData.praiseNumber }})</span>
          <span>中评({{ prodCommData.secondaryNumber }})</span>
          <span>差评({{ prodCommData.negativeNumber }})</span>
          <span>有图({{ prodCommData.picNumber }})</span>
        </div>
        <div class="cmt-items">
          <div
            class="cmt-item"
            v-for="(item, index) in littleCommPage"
            :key="index"
          >
            <div class="cmt-user">
              <span class="date">{{ item.recTime }}</span>
              <div class="cmt-user-info">
                <img
                  :src="item.pic ? item.pic : '../../images/icon/head04.png'"
                  alt=""
                  srcset=""
                  class="user-img"
                />
                <div class="nickname">
                  {{ item.isAnonymous == 1 ? "匿名评价" : item.nickName }}
                </div>
                <van-rate :size="15" v-model="item.score" readonly />
              </div>
              <div class="cmt-cnt">{{ item.content }}</div>
            </div>
            <van-divider />
          </div>
        </div>
        <div class="cmt-more-v" v-if="prodCommPage.records.length > 2">
          <text @click="showComment">查看全部评价</text>
        </div>
      </div>
    </div>
    <!-- 评论end -->
    <!-- 产品描述信息 -->
    <div class="goods_desc" v-html="info.content"></div>
    <!-- 产品列表 -->
    <!-- <Weekproduct :newGoodsList="goodsList" title="相关产品"> </Weekproduct> -->

    <!-- 添加购物车面板 -->
    <!-- <van-sku
      v-model="show"
      ref="sku"
      :sku="sku"
      :goods="goods"
      :hide-stock="sku.hide_stock"
      @add-cart="onAddCartClicked"
    /> -->
    <van-popup
      v-model="show"
      closeable
      round
      position="bottom"
      :style="{ height: '60%' }"
    >
      <div class="pup-sku-main radius">
        <div class="pup-sku-header radius">
          <div class="pup-sku-img">
            <img :src="defaultSku.pic ? defaultSku.pic : pic" alt="" />
          </div>
          <div class="pup-sku-prod">
            <div class="pup-sku-price" v-if="findSku" style="display: flex; align-items: center;">
              <template v-if="activityId === 9 || activityId === 13">
                <img src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" alt="积分" style="width: 16px; height: 16px; margin-right: 4px;"/>
              </template>
              <span v-else>￥</span>
              <span class="pup-sku-price-int">{{ defaultSku.price }}</span>
            </div>
            <view v-else class="pup-sku-price">无货</view>
            <div class="pup-sku-prop">
              <span>已选</span>
              <span
                >&nbsp;{{ selectedProp.length > 0 ? selectedProp + "，" : ""
                }}{{ prodNum }}&nbsp;件</span
              >
            </div>
          </div>
        </div>
        <div class="pup-sku-body">
          <div class="pup-sku-area">
            <div v-for="(item,index) in skuGroup" :key="index">
              <div class="sku-kind">{{index}}</div>
              <div class="sku-choose">
                <div v-for="(value,i) in item" :key="i">
                  <span 
                    class="sku-choose-item" 
                    :class="{active: selectedPropObj[index] === value}"
                    @click="selectProp(index, value)"
                  >{{value}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="pup-sku-count">
            <div class="num-wrap">
              <div class="minus" @click="onCountMinus">
                <span class="row"></span>
              </div>
              <div class="text-wrap">
                <input type="number" :value="prodNum" />
              </div>
              <div class="plus" @click="onCountPlus">
                <span class="row"></span>
                <span class="col"></span>
              </div>
            </div>
            <div class="count-name">数量</div>
          </div>
        </div>
      </div>
      <van-goods-action>
        <van-goods-action-button @click="onAddCartClicked" type="warning" text="加入购物车" :disabled="addToCartDisabled" />
        <van-goods-action-button @click="getPurchase" type="danger" text="立即购买" :disabled="addToCartDisabled" />
      </van-goods-action>
    </van-popup>

    <!-- 下方购物车      -->
    <van-goods-action>
      <!-- <van-goods-action-icon
        :icon="star_flag ? 'star' : 'star-o'"
        :text="star_flag ? '已收藏' : '未收藏'"
        :color="star_flag ? '#ff5000' : '#323233'"
        @click="clickFn"
      /> -->
      <van-goods-action-icon
        icon="wap-home"
        text="首页"
        @click="$router.push('/home')"
      />
      <!-- <van-goods-action-icon
        icon="service-o"
        text="客服"
        @click="$router.push('/cart')"
      /> -->
      <van-goods-action-icon
        icon="cart-o"
        text="购物车"
        :badge="badge"
        @click="goToCart"
      />
      <van-goods-action-button
        type="warning"
        text="加入购物车"
        @click="addCar"
        :disabled="addToCartDisabled"
      />
      <van-goods-action-button type="danger" text="立即购买" @click="addCar" :disabled="addToCartDisabled" />
    </van-goods-action>
  </div>
</template>

<script>
import {
  getDetailData,
  AddToCart,
  GetCartCountData,
  getProdCommData,
  getProdCommPageByProd,
  Getaddress,
  GetRegionBuyLimit
} from "@/https/http";
// import Weekproduct from "@/views/home/Weekproduct";
// 导入URL工具函数
// import { getActivityIdFromRoute } from "@/utils/urlUtil";
import { Toast } from 'vant';
export default {
  name: "product-detail",
  data() {
    return {
      prodNum: 1,
      announcement:'',
      gallery: [],
      info: {},
      attribute: [], //参数
      show: false,
      defaultSku: undefined,
      pic: "",
      shopId: 1,
      findSku: true,
      price: 0,
      selectedProp: [],
      selectedPropObj: {},
      selectedProperties: "",
      skuGroup: {},
      distributionCardNo: "", //分销员卡号
      propKeys: [],
      allProperties: [],
      productList: [], // 当前产品信息
      issue: [],
      goodsList: [],
      star_flag: false,
      badge: 0,
      evaluate: -1,
      prodCommData: [], //评论列表数据
      littleCommPage: [], //评论列表内容
      prodCommPage: {
        current: 0,
        pages: 0,
        records: [],
      },
      addressState: false, // 是否有默认地址
      addressList: {}, // 地址信息
      isFlashing: false, // 闪烁效果
      // activityId: null, //活动ID
      addToCartDisabled: false, // 是否禁用购买按钮
    };
  },
    computed: {
    // 从全局状态获取活动ID
    // globalActivityId() {
    //   return this.$store.getters.getActivityId;
    // }
  },
  created() {
        // 优先从全局状态获取活动ID，如果没有则从路由获取
    // if (this.globalActivityId) {
    //   this.activityId = this.globalActivityId;
    // } else {
    //   this.activityId = getActivityIdFromRoute(this.$route);
    //   // 将活动ID保存到全局状态中
    //   if (this.activityId) {
    //     this.$store.dispatch('updateActivityId', this.activityId);
    //   }
    // }
    this.GetDetailData();
    this.getCartData();
    this.getCommData(); // 评论数据列表
    this.getPageByProd(); //评论内容获取列表
    
  },
  methods: {
    /**
     * 减数量
     */
    onCountMinus: function () {
      var prodNum = this.prodNum;
      if (prodNum > 1) {
        this.prodNum--;
      }
    },

    /**
     * 加数量
     */
    onCountPlus: function () {
      var prodNum = this.prodNum;
      if (prodNum < 1000) {
        this.prodNum++;
      }
    },
    addCar() {
      if(!this.addressState){
        this.backToTops()
        console.log('scrollToSku');
        return
      }
      this.show = true;
      
    },
    showSku() {
      if(!this.addressState){
        this.backToTops()
        console.log('scrollToSku');
        return
      }
      this.show = true;
    },
    backToTops() {
      window.scrollTo({
        top: 200,
        behavior: 'smooth'
      });
      this.isFlashing = !this.isFlashing;
      setTimeout(() => {
        this.isFlashing = !this.isFlashing;
      }, 3000);
    },
    getPurchase(){
      if(!this.addressState){
        this.backToTops()
        console.log('scrollToSku');
        return
      }
      this.show = true;
      const orderItem = {  
        prodId: this.$route.query.id,  
        skuId: this.defaultSku.skuId,  
        prodCount: this.prodNum,  
        shopId: this.shopId,  
        distributionCardNo: this.distributionCardNo  
      };  
      // 将对象转换为字符串并保存到sessionStorage
      sessionStorage.setItem('orderItem', JSON.stringify(orderItem)); 
      this.$router.push({ name: 'submit-order',params: { orderEntry: '1' }})
    },
    // 加入购物车
    onAddCartClicked() {
      let obj = {};
      obj.basketId=0,
      obj.attribute=1,
      obj.count=this.prodNum,
      obj.prodId=this.$route.query.id;
      obj.shopId= this.shopId,
      obj.skuId=this.defaultSku.skuId,
      obj.distributionCardNo=this.distributionCardNo
      AddToCart(obj).then((res) => {
        console.log(res);
        // 显示添加成功
        this.$toast.success("添加成功");
        this.getCartData();
      });
      // 隐藏 商品规格面板
      this.show = false;
    },
    goToCart(){
      this.$eventBus.$emit( 'changeCount')
     this.$router.push('/cart') 
    },
    //加入购物车
  // callChangeItem() {
  //   http.request({
  //     url: "/p/shopCart/changeItem",
  //     method: "POST",
  //     data: {
  //       basketId: 0,
  //       attribute:this.data.prodState == 0 ?2:1,
  //       count: this.data.prodNum,
  //       prodId: this.data.prodId,
  //       shopId: this.data.shopId,
  //       skuId: this.data.defaultSku.skuId,
  //       distributionCardNo: this.data.distributionCardNo
  //     },
  //     callBack: (res) => {
  //       console.log(res,'res');
  //       this.setData({
  //         totalCartNum: this.data.totalCartNum + this.data.prodNum,
  //         skuShow: false
  //       });
  //       wx.hideLoading();
  //       wx.showToast({
  //         title: "加入购物车成功",
  //         icon: "none"
  //       })
  //     }
  //   });
  // },
    // 获取产品明细数据列表
    GetDetailData() {
      // 当activityId等于12、14，不传递h5参数
      let params = { prodId: this.$route.query.id, attribute: 1 };
      // if (this.activityId !== 12 && this.activityId !== 14) {
      //   params.h5 = this.activityId || 8;
      // }
      getDetailData(params).then(
        (res) => {
          console.log(33, res);
          (this.price = res.data.price),
            // 组装sku
            this.groupSkuProp(res.data.skuList);
          var imgStrs = res.data.imgs;
          let img = imgStrs.split(",");
          console.log(img);
          this.gallery = img;
          this.info = res.data;
          this.skuList = res.data.skuList;
          this.pic = res.data.pic;
          this.announcement = res.data.announcement;
          // 产品数据加载完成后再获取地址并检查配送
          this.getGetaddress();
        }
      );
    },
    getGetaddress(){
      console.log('获取地址');
      
      Getaddress().then((res) => {
        console.log(res,'地址11111');
        if (res.data.length > 0) {
          this.addressState = true;
          this.addressList = res.data[0];
          // 遍历地址列表，判断是否能配送
            const addrId = res.data[0].addrId;
            this.getRegionBuy(addrId)
        } else {
          this.addressState = false;
        }
      });
    },
    //是否可配送
    getRegionBuy(addrId) {
      // 确保 defaultSku 已初始化
      if (!this.defaultSku || !this.defaultSku.skuId) {
        console.log('defaultSku 尚未初始化，无法检查配送');
        return;
      }
      console.log('判断是否能配送',addrId,this.defaultSku.skuId);
      let data = {
            sku:[{ skuId:this.defaultSku.skuId } ],
            userAddrId:addrId,
      }
      GetRegionBuyLimit(data).then((res) => {
        console.log("是否能配送", res.data);
        // 检查是否返回"该默认地址不支持发货"
        if(res.data == '该默认地址不支持发货') {
          this.addToCartDisabled = true;
          Toast('该默认地址不支持发货');
        } else {
          this.addToCartDisabled = false;
        }
      }).catch((err) => {
        console.log(err);
        this.addToCartDisabled = true;
        Toast('该默认地址不支持发货');
      });
    },
    //根据sku的属性 分组
    groupSkuProp(skuList) {
      if (skuList.length == 1 && skuList[0].properties == "") {
        this.defaultSku = skuList[0];
        return;
      }
      var skuGroup = {};
      var allProperties = [];
      var propKeys = [];
      this.selectedPropObj = {};
      
      // 先遍历一遍获取所有规格类型和值
      for (var i = 0; i < skuList.length; i++) {
        var properties = skuList[i].properties;
        var propList = properties.split(";");
        
        for (var j = 0; j < propList.length; j++) {
          var propval = propList[j].split(":");
          var propKey = propval[0];
          var propValue = propval[1];
          
          if (!skuGroup[propKey]) {
            skuGroup[propKey] = [];
            propKeys.push(propKey);
          }
          if (!this.array_contain(skuGroup[propKey], propValue)) {
            skuGroup[propKey].push(propValue);
          }
        }
        allProperties.push(properties);
      }
      
      // 设置默认选中第一个SKU的规格
      var defaultSku = skuList[0];
      var defaultProps = defaultSku.properties.split(";");
      for (var k = 0; k < defaultProps.length; k++) {
        var prop = defaultProps[k].split(":");
        this.selectedPropObj[prop[0]] = prop[1];
      }
      
      this.defaultSku = defaultSku;
      this.allProperties = allProperties;
      this.skuGroup = skuGroup;
      this.propKeys = propKeys;
      
      this.parseSelectedObjToVals(skuList);
    },
    //将已选的 {key:val,key2:val2}转换成 [val,val2]
    parseSelectedObjToVals(skuList) {
      var selectedPropObj = this.selectedPropObj;
      var selectedProperties = "";
      var selectedProp = [];
      
      for (var key in selectedPropObj) {
        selectedProp.push(selectedPropObj[key]);
        selectedProperties += key + ":" + selectedPropObj[key] + ";";
      }
      
      selectedProperties = selectedProperties.substring(0, selectedProperties.length - 1);
      this.selectedProperties = selectedProperties;
      this.selectedProp = selectedProp;
      
      var findSku = false;
      for (var i = 0; i < skuList.length; i++) {
        if (skuList[i].properties == selectedProperties) {
          findSku = true;
          this.defaultSku = skuList[i];
          break;
        }
      }
      this.findSku = findSku;
    },
    //判断数组是否包含某对象
    array_contain(array, obj) {
      for (var i = 0; i < array.length; i++) {
        if (array[i] == obj) return true;
      }
      return false;
    },
    
    // 选择规格
    selectProp(propKey, propValue) {
      this.selectedPropObj[propKey] = propValue;
      this.parseSelectedObjToVals(this.skuList);
    },
    
    // 获取相关产品数据列表
    // getRelatedData() {
    //   GetGoodsRelatedData({ id: this.$route.query.id }).then((res) => {
    //     console.log(3366, res);
    //     this.goodsList = res.data.goodsList;
    //   });
    // },
    // 获取相关产品评论数据列表/prod/prodCommData
    getCommData() {
      getProdCommData({ prodId: this.$route.query.id }).then((res) => {
        console.log("产品评论数据", res);
        this.prodCommData = res.data;
      });
    },
    //获取相关产品评论内容列表/prod/prodCommPageByProd
    getPageByProd(e) {
      if (e) {
        if (e.evaluate === this.evaluate) {
          return;
        }
        this.prodCommPage.current = 0;
        this.prodCommPage.pages = 0;
        this.prodCommPage.records = [];
        this.evaluate = e.evaluate;
      }
      getProdCommPageByProd({
        prodId: this.$route.query.id,
        size: 10,
        current: this.prodCommPage.current + 1,
        evaluate: this.evaluate,
      }).then((res) => {
        console.log("产品评论内容", res);
        res.data.records.forEach((item) => {
          if (item.pics) {
            item.pics = item.pics.split(",");
          }
        });
        let records = this.prodCommPage.records;
        records = records.concat(res.data.records);
        this.prodCommPage.current = res.data.current;
        this.prodCommPage.pages = res.data.pages;
        this.prodCommPage.records = records;
        // 如果商品详情中没有评论的数据，截取两条到商品详情页商品详情
        if (!this.littleCommPage.length) {
          this.littleCommPage = records.slice(0, 2);
        }
      });
    },
    // 获取购物车商品数量
    getCartData() {
      GetCartCountData().then((res) => {
        console.log(7778, res);
        this.badge = res.data;
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    clickFn() {
      this.star_flag = !this.star_flag;
      if (this.star_flag) {
        this.$toast("收藏成功");
      } else {
        this.$toast("取消宝贝收藏成功");
      }
    },
    toAddressList() {
      this.$router.push({ name: "delivery-address",params:{prodaddr:0,id:this.$route.query.id} });
    },
  },
  // components: {
  //   Weekproduct,
  // },
};
</script>

<style lang="less" scoped>
.product-detail-box {
  font-size: 14px;
  line-height: 30px;
  padding-bottom: 100px;

.flashing {
  animation: flashBorder 1s infinite alternate;
}

@keyframes flashBorder {
  0% {
    box-shadow: 0 0 10px rgba(255, 0, 0, 0.5), 0 0 20px rgba(255, 0, 0, 0.5), 0 0 30px rgba(255, 0, 0, 0.5);
  }
  100% {
    box-shadow: none;
  }
}
  img {
    width: 100%;
    height: 9rem;
  }
  .info {
    text-align: center;

    .info-brief {
      color: #666;
    }
    .info-price {
      color: red;
    }
  }
  .attribute {
    ul {
      li {
        border-bottom: 1px solid #eee;
        font-size: 12px;
        display: flex;
        .attribute-name {
          width: 15%;
        }
        .attribute-value {
          flex: 1;
        }
      }
    }
  }
  .mytitle {
    text-align: center;
    font-size: 16px;
    margin-top: 20px;
    position: relative;
    height: 50px;
    span {
      width: 50%;
      height: 2px;
      background-color: #ccc;
      display: inline-block;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    h3 {
      width: 30%;
      background-color: #fff;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .issue {
    li {
      h3 {
        padding-left: 10px;
        line-height: 20px;
        position: relative;
        &:before {
          content: "";
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: red;
          display: inline-block;
          position: absolute;
          left: 2px;
          top: 50%;
          margin-top: -2px;
        }
      }
      margin-bottom: 15px;
    }
  }
  /deep/.goods_desc {
    img {
      width: 100%;
    }
  }
}
.prod-info {
  padding: 15px 15px 0 15px;
  position: relative;
  background: #fff;
}
.tit-wrap {
  position: relative;
  line-height: 20px;
  padding-right: 52px;
  .col {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    color: #666;
    font-size: 10px;
    padding-left: 10px;
    text-align: center;
    img {
      display: block;
      margin: auto;
      width: 20px;
      height: 20px;
    }
  }
}
.prod-tit {
  font-size: 16px;
  color: #333;
  padding-right: 10px;
  word-break: break-all;
}
.prod-price {
  font-size: 15px;
  height: 38px;
  line-height: 50px;
}
.price {
  color: #e43130;
  font-size: 12px;
  font-weight: 600;
  margin-right: 1px;
}
.price-num {
  color: #e43130;
  font-size: 23px;
  font-weight: 400;
}
.box-radius {
  border-radius: 10px;
}
.sku {
  padding: 10px;
  background: #fff;
  margin-top: 10px;
  position: relative;
  line-height: 24px;
}
.sku-tit {
  position: absolute;
  display: inline-block;
  width: 30px;
  left: 10px;
  font-size: 11px;
  top: 10px;
  color: #999;
}
.sku-con {
  margin: 0 40px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 14px;
  font-weight: bold;
}
.more {
  position: absolute;
  right: 10px;
  width: 30px;
  top: 5px;
  text-align: right;
  font-size: 20px;
  color: #999;
  letter-spacing: 1px;
}
.box-radius {
  border-radius: 10px;
}
.cmt-wrap {
  background: #fff;
  margin-top: 10px;
  position: relative;
  line-height: 24px;
}
.cmt-tit {
  font-size: 16px;
  position: relative;
  border-bottom: 1px solid #ddd;
  padding: 10px;
}
.cmt-t {
  width: 150px;
}
.cmt-good {
  color: #e43130;
  font-size: 12px;
}
.cmt-count {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 12px;
  color: #666;
}
.cmt-more {
  width: 10px;
  height: 10px;
  border-top: 1px solid #999;
  border-right: 1px solid #999;
  transform: rotate(45deg);
  margin-left: 5px;
  display: inline-block;
}
.cmt-cont {
  padding: 0 10px;
}
.cmt-tag {
  position: relative;
  padding: 14px 3px 0 0;
  margin: 0;
  span {
    margin: 0 10px 10px 0;
    background: #fdf0f0;
    display: inline-block;
    padding: 0 10px;
    height: 25px;
    border-radius: 3px;
    line-height: 25px;
    font-size: 12px;
    font-family: -apple-system, Helvetica, sans-serif;
    color: #666;
  }
}
.cmt-item {
  position: relative;
  padding: 10px 0;
}
.cmt-user {
  line-height: 25px;
  margin-bottom: 8px;
  font-size: 12px;
  .date {
    float: right;
    color: #999;
    margin-left: -60px;
  }
  .cmt-user-info {
    display: flex;
    align-items: center;
    width: 400rpx;
    .user-img {
      width: 25px;
      height: 25px;
      border-radius: 50%;
      vertical-align: middle;
    }
    .nickname {
      margin-left: 10px;
      display: inline-block;
      color: #333;
      max-width: 8.2em;
      height: 25px;
      line-height: 27px;
    }
  }
  .cmt-cnt {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    position: relative;
    line-height: 1.5;
    font-size: 14px;
    margin: 5px 0;
    word-break: break-all;
    max-height: 126px;
    ::after {
      content: "";
      height: 0;
      display: block;
      border-bottom: 1px solid #ddd;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      right: -10px;
      border-bottom-color: #e5e5e5;
      border-bottom-width: 1px;
      border-bottom-style: solid;
    }
  }
}
.cmt-more-v {
  text-align: center;
  background-color: #fff;
  font-size: 12px;
  text {
    height: 25px;
    line-height: 25px;
    font-size: 12px;
    text-align: center;
    color: #333;
    padding: 0px 10px;
    margin: 10px 0;
    border: 1px solid #ccc;
    border-radius: 40px;
    display: inline-block;
  }
}
.pup-sku-header {
  position: relative;
  font-size: 16px;
  color: #333;
  padding: 10px 10px;
  background-color: #fff;
  border-bottom: 1px solid #f2f2f2;
  padding-top: 12px;
  .pup-sku-img {
    display: inline-block;
    width: 27%;
    height: 90px;
    vertical-align: middle;
    border-radius: 5px;
    img {
      display: block;
      width: 90px;
      height: 100%;
    }
  }
  .pup-sku-prod {
    display: inline-block;
    width: 70%;
    vertical-align: middle;
    padding-left: 5px;
    .pup-sku-price {
      display: inline-block;
      color: #e4393c;
      font-size: 14px;
      margin-bottom: 8px;
      .pup-sku-price-int {
        font-size: 18px;
      }
    }
    .pup-sku-prop {
      word-break: break-all;
      font-size: 12px;
      color: #333;
      line-height: 1.4em;
      padding-right: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}
.pup-sku-body {
  box-sizing: border-box;
  max-height: 379px;
  padding-bottom: 100px;
  overflow: auto;
  .pup-sku-count {
    padding: 10px 13px;
    font-size: 12px;
    .num-wrap {
      position: relative;
      z-index: 0;
      width: 110px;
      float: right;
      vertical-align: middle;
      display: flex;
      .minus {
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
        position: relative;
        max-width: 30px;
        min-width: 30px;
        height: 30px;
        line-height: 30px;
        background: #f7f7f7;
        text-align: center;
        .row {
          border-radius: 20px;
          position: absolute;
          top: 50%;
          left: 50%;
          margin-left: -7px;
          margin-top: -1px;
          width: 14px;
          height: 2px;
          background-color: #ccc;
        }
      }
      .text-wrap {
        position: relative;
        width: 45px;
        z-index: 0;
        margin: 0 1px;
        input {
          height: 30px;
          width: 100%;
          color: #333;
          background: #fff;
          font-size: 12px;
          text-align: center;
          border: none;
          background: #f7f7f7;
        }
      }
      .plus {
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
        position: relative;
        max-width: 30px;
        min-width: 30px;
        height: 30px;
        line-height: 30px;
        background: #f7f7f7;
        text-align: center;
        .row {
          border-radius: 20px;
          position: absolute;
          top: 50%;
          left: 50%;
          margin-left: -7px;
          margin-top: -1px;
          width: 14px;
          height: 2px;
          background-color: #ccc;
        }
        .col {
          border-radius: 20px;
          position: absolute;
          top: 50%;
          left: 50%;
          margin-left: -1px;
          margin-top: -7px;
          width: 2px;
          height: 14px;
          background-color: #999;
        }
      }
    }
  }
  .pup-sku-area {
    .sku-kind {
      font-size: 12px;
      color: #999;
      margin: 0 10px;
      height: 40px;
      line-height: 40px;
    }
    .sku-choose {
      overflow: hidden;
      margin-bottom: 3px;
      .sku-choose-item {
        display: inline-block;
        min-width: 50px;
        max-width: 270px;
        padding: 0 8px;
        overflow: hidden;
        height: 25px;
        line-height: 25px;
        text-align: center;
        margin-left: 10px;
        margin-bottom: 10px;
        border-radius: 15px;
        color: #333;
        background-color: #f7f7f7;
        font-size: 14px;
        border: 1px solid #aaa;
      }
      .active {
        background-color: #e43130;
        color: #fff;
        border: 1px solid #e43130 !important;
      }
    }
  }
}
.prod-price {
  display: flex;
  align-items: baseline;
  height: 38px;
  line-height: 50px;
}

.symbol {
  color: #E0370F;
  font-size: 16px;
  font-weight: 500;
}

.big-num {
  color: #E0370F;
  font-size: 23px;
  font-weight: 700;
}

.small-num {
  color: #E0370F;
  font-size: 16px;
  font-weight: 500;
}

.prices {
  display: flex;
  align-items: center;
  margin-top: 5px;
}

.symbols {
  color: #999;
  font-size: 12px;
}

.ori-price {
  color: #999;
  font-size: 14px;
  text-decoration: line-through;
  margin-left: 2px;
}
</style>
